import { Component } from '@angular/core';
import { DesyAngularModule } from 'desy-angular';

@Component({
  selector: 'app-footer',
  imports: [DesyAngularModule],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
  standalone: true,
})
export class FooterComponent {}
